import React from "react";
import Icon1 from "../../assets/p2.jpg";
import Icon2 from "../../assets/p1.jpeg";
import Icon3 from "../../assets/p3.jpeg";
import IconD from "../../assets/user.jpg";
import {
  ServicesContainer,
  ServicesH,
  ServicesH1,
  ServicesWrapper,
  ServicesCard,
  ServicesIcon,
  ServicesH2,
  ServicesP,
} from "./ServicesElements";

const Services = () => {
  return (
    <ServicesContainer id="team">
      <ServicesH1>Our Team</ServicesH1>
      <ServicesWrapper>
        <ServicesCard>
          <ServicesIcon src={IconD} />
          <ServicesH2>
            <span style={{ fontWeight: "bold" }}>Abraham Swenifu Kiazolu</span>
          </ServicesH2>
          <span style={{ fontSize: "0.8rem", fontWeight: "bold" }}>
            CEO - LMTSS
          </span>
          <ServicesP>
            Engage in motocycles & tricycles transportation services since 2015
            to present.
          </ServicesP>
        </ServicesCard>

        <ServicesCard>
          <ServicesIcon src={IconD} />
          <ServicesH2>
            <span style={{ fontWeight: "bold" }}>Abraham Freeman</span>
          </ServicesH2>
          <span style={{ fontSize: "0.8rem", fontWeight: "bold" }}>
            Secretary General - LMTSS
          </span>
          <ServicesP>Assistant Sale Manager at SAO Business Center.</ServicesP>
        </ServicesCard>

        {/* <ServicesCard> */}
        {/*   <ServicesIcon src={IconD} /> */}
        {/*   <ServicesH2> */}
        {/*     <span style={{ fontWeight: "bold" }}>Ebenezer C. Jeboe</span> */}
        {/*   </ServicesH2> */}
        {/*   <span style={{ fontSize: "0.8rem", fontWeight: "bold" }}> */}
        {/*     Chief of Security - LMTSS */}
        {/*   </span> */}
        {/*   <ServicesP>Work with motocyclists in various capacities.</ServicesP> */}
        {/* </ServicesCard> */}
      </ServicesWrapper>
    </ServicesContainer>
  );
};

export default Services;
